import { render, staticRenderFns } from "./SummaryQRRegistration.vue?vue&type=template&id=82486fd2&scoped=true"
import script from "./SummaryQRRegistration.vue?vue&type=script&lang=js"
export * from "./SummaryQRRegistration.vue?vue&type=script&lang=js"
import style0 from "./SummaryQRRegistration.vue?vue&type=style&index=0&id=82486fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82486fd2",
  null
  
)

export default component.exports